import { reactive } from 'vue'

const theme = reactive({
  agentLogo: '',
  devLogo: 'logo-white.png',
  apiUrl: 'https://api.metaluxe.com.au/',
  bunnyApiUrl: 'https://api.bunny.net/',

  videoLibraryId: '',
  streamCdnUrl: '',
  streamApiKey: '',

  storageApiPassword: '8e33a4c6-1d23-47d7-b3eac9263798-9e3d-4c0d',
  cdnUrl: 'https://50sunset.b-cdn.net',
  devFolder: '/50sunset',

  CinematicsIcon: '/img/ui-theme/videos-icon.svg',
  rendersIcon: '/img/ui-theme/renders-icon.svg',
  rangeIcon: '/img/ui-theme/range-icon.svg',
  panoramasIcon: '/img/ui-theme/panoramas-icon.svg',
  '360-ToursIcon': '/img/ui-theme/panoramas-icon.svg',

  dashboardMp4: 'theme/dashboard/bg-video.mp4',

  // top level menu
  assetsMenuOrder: ['Cinematics', '360-Tours'],

  orderAssetsMenu: ['3 Bed', 'Amenities', 'Exterior'],

  SunsetAsset: {
    panoramas: [0],
    panoramasName: ['50 Sunset'],
    panoramasUrl: ['https://storage.net-fs.com/hosting/7566552/168/'],
    balconyViews: [0],
    balconyViewsName: ['50 Sunset'],
    balconyViewsUrl: [''],
    floorplans: [],
    floorplansName: [],
    floorplansUrl: [],
  },
})

export default { theme }
